import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {HttpService} from "../../../services/http.service";
import {JBMSelectOption} from "../../../components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component";
import {UnloadingMethod} from "./interfaces/unloading-method";

const baseURL: string = 'projects/';
const slug: string = 'unloading_methods/';

@Injectable({
  providedIn: 'root'
})
export class UnloadingMethodsService {

  constructor(private HttpService: HttpService) { }

  get(language: string, params: HttpParams=null) {
    return this.HttpService.get(baseURL+'read/'+slug+language, params);
  }
  getByID(id: number) {
    return this.HttpService.get(baseURL+'read/'+slug+'getbyid/'+id.toString());
  }
  getOne(id: number, language: string) {
    let params=new HttpParams().append('subject_id', id.toString());
    return this.HttpService.get(baseURL+'read/'+slug+language, params);
  }
  getSelectOptions(unloadingMethods: UnloadingMethod[], includeEmptyOption: boolean=false): JBMSelectOption[] {
    let options: JBMSelectOption[]=[];
    if(includeEmptyOption) options.push({key: '', value: ''});
    for(let uls=0; uls<unloadingMethods.length; uls++)
      options.push({key: unloadingMethods[uls].id.toString(), value: unloadingMethods[uls].description});
    return options;
  }
  create(data: any) {
    return this.HttpService.post(baseURL+'create/'+slug, data);
  }
  update(data: any) {
    return this.HttpService.post(baseURL+'update/'+slug, data);
  }
}
